import React from "react";
import styled, { css } from "styled-components";
import NextLazyImage from "@/components/Core/NextLazyImage";
import LabelCta from "@/components/Buttons/LabelCta";
import mq from "@/utils/mq";

interface CaseStudySliderItemCardProps {
  caseStudy: any;
}

const CaseStudyCardContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid rgba(62, 62, 68, 0.36);
  background:
    linear-gradient(179deg, #08090a 0.75%, rgba(0, 0, 0, 0) 31.49%),
    linear-gradient(90deg, rgba(8, 9, 10, 0.72) 0%, rgba(0, 0, 0, 0) 50%),
    linear-gradient(270deg, rgba(8, 9, 10, 0.72) 3.33%, rgba(0, 0, 0, 0) 50%),
    linear-gradient(359deg, #08090a 0.42%, rgba(0, 0, 0, 0) 49.66%);
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  user-select: none;
`;

const ContentOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  padding: 18px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  user-select: none;
  ${mq.mobile(css`
    padding: 16px;
    gap: 4px;
  `)};
`;

const CaseStudyTitle = styled.h3`
  margin: 0;
  color: #f7f8f8;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: var(--font-pp-neue);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.25px;
  ${mq.mobile(css`
    font-size: 20px;
  `)};
`;

const CaseStudyCtaWrapper = styled.div``;

const CaseStudyLogo = styled.div`
  width: 100%;
  height: 30px;
  z-index: 5;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export default function CaseStudySliderItemCard({ caseStudy }: CaseStudySliderItemCardProps) {
  const title = caseStudy?.title;
  const backgroundImage = caseStudy?.backgroundImage;
  const link = caseStudy?.link;
  const full_slug = link?.story?.full_slug;
  const imageFilename = backgroundImage?.filename;
  const ctaRef = React.useRef<HTMLDivElement>(null);
  if (!title || !imageFilename || !full_slug) {
    console.warn("CaseStudySliderItemCard received incomplete props:", caseStudy);
    return null;
  }

  const handleContainerClick = () => {
    const linkElement = ctaRef.current?.querySelector("a, button");
    if (linkElement instanceof HTMLElement) {
      linkElement.click();
    }
  };

  console.log(caseStudy);

  return (
    <CaseStudyCardContainer onClick={handleContainerClick}>
      <ImageWrapper>
        <NextLazyImage
          src={imageFilename}
          alt={backgroundImage?.alt || title}
          fill
          style={{ objectFit: "cover", width: "100%", height: "100%" }}
        />
      </ImageWrapper>
      <ContentOverlay>
        <CaseStudyLogo>
          <NextLazyImage
            src={caseStudy?.logo?.filename}
            alt={caseStudy?.logo?.alt}
            fill
            style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left" }}
          />
        </CaseStudyLogo>
        <CaseStudyTitle>{title}</CaseStudyTitle>
        <CaseStudyCtaWrapper ref={ctaRef}>
          <LabelCta rawLink={"/" + full_slug} label='Read story' includeArrow color='#ffffff' colorOverride />
        </CaseStudyCtaWrapper>
      </ContentOverlay>
    </CaseStudyCardContainer>
  );
}
